import { render, staticRenderFns } from "./modify-password-form.vue?vue&type=template&id=76fb2e9e&scoped=true&"
import script from "./modify-password-form.vue?vue&type=script&lang=js&"
export * from "./modify-password-form.vue?vue&type=script&lang=js&"
import style0 from "./modify-password-form.vue?vue&type=style&index=0&id=76fb2e9e&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fb2e9e",
  null
  
)

export default component.exports